const COLORS = {
  backgroundGreen: '#DBF1D1',
  backgroundTurquoise: '#B7DBDB',
  backgroundGray: '#F9F9F9',
};

export default COLORS;
